import React from "react";
import { BaseInternalFormFactory } from "../../base-internal-form/base-internal-form-factory";
import { LookupManager } from "./lookup-manager";
import AdminPortalAppService from "../../../application/platform/admin-portal/admin-portal-app-service";

const FornecedoresFactory = () => {
    return (
        <BaseInternalFormFactory pageTitle={"Fornecedores"}>
            <LookupManager
                title="Fornecedores"
                fields={[
                    { key: "nomFornecedor", label: "Nome", required: true, maxLength: 100 },
                    { key: "cnpjcpf", label: "CNPJ/CPF", required: true, maxLength: 18 },
                    { key: "uf", label: "UF", required: true, maxLength: 2 },
                    { key: "cidade", label: "Cidade", required: true, maxLength: 100 }
                ]}
                listFn={AdminPortalAppService.listFornecedores}
                addUpdateFn={AdminPortalAppService.addUpdateFornecedor}
                variant="standalone"
            />
        </BaseInternalFormFactory>
    );
};

export default FornecedoresFactory;
